import { useEffect, useState } from 'react';

export enum LayoutSize {
  mobile = 'mobile',
  tablet = 'tablet',
  desktop = 'desktop',
  monitor = 'monitor',
}

const LAYOUT_MIN_MAX_WIDTHS: Record<LayoutSize, [number, number]> = {
  [LayoutSize.mobile]: [0, 655],
  [LayoutSize.tablet]: [655, 916],
  [LayoutSize.desktop]: [916, 1920],
  [LayoutSize.monitor]: [1920, Number.MAX_SAFE_INTEGER],
};

export function responsiveLayoutSize() {
  const width = window?.innerWidth;

  if (width === undefined) return null;

  return Object.entries(LAYOUT_MIN_MAX_WIDTHS).find(
    ([, [min, max]]) => width >= min && width < max,
  )?.[0] as LayoutSize | null;
}

function useLayoutSize() {
  const [currentSize, setCurrentSize] = useState(() => responsiveLayoutSize());

  useEffect(() => {
    const handleResize = () => {
      const newCurrentSize = responsiveLayoutSize();
      if (newCurrentSize !== currentSize) {
        setCurrentSize(newCurrentSize);
      }
    };

    window.addEventListener('resize', handleResize, { passive: true });

    return () => window.removeEventListener('resize', handleResize);
  }, [currentSize]);

  return currentSize;
}

export default useLayoutSize;
